import { SVGProps } from "react";
const LockUnlockSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg width={22} height={22} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5833 19.25H6.41667C5.40375 19.25 4.58333 18.4296 4.58333 17.4167V11C4.58333 9.98708 5.40375 9.16667 6.41667 9.16667H15.5833C16.5962 9.16667 17.4167 9.98708 17.4167 11V17.4167C17.4167 18.4296 16.5962 19.25 15.5833 19.25Z"
      stroke="white"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6667 6.41667C14.6667 4.39175 13.0249 2.75 11 2.75C9.28583 2.75 7.85767 3.93158 7.45617 5.52108"
      stroke="white"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6667 9.16667V6.41667"
      stroke="white"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default LockUnlockSvg;
